module.exports = __webpack_public_path__ + "assets/img/AstonRX-Landing-Page-w960.121302f7.jpg";